module.exports = __webpack_public_path__ + "product-pure-powder-capsule-08.jpg?c2f80755a6a98d9b2dcffa04beac40fb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-pure-powder-capsule-08.jpg
// module id = 90
// module chunks = 0